import { Injectable } from '@angular/core'
import { SignupAttributes } from '@ftr/api-shared'

@Injectable()
export class SignupAttributesService {
  attributes: SignupAttributes | undefined
}
